export default __webpack_public_path__ + "static/media/project10.72c82775.PNG";